// @ts-nocheck
import { injectCss } from "@insite/mobius/utilities";
import InjectableCss, { StyledProp } from "@insite/mobius/utilities/InjectableCss";
import MobiusStyledComponentProps from "@insite/mobius/utilities/MobiusStyledComponentProps";
import React, { FC } from "react";
import styled from "styled-components";

export interface VideoPlayerPresentationProps {
    /** CSS string or styled-components function to be injected into this component.
     * @themable */
    css?: StyledProp<VideoPlayerProps>;
}

export type VideoPlayerProps = MobiusStyledComponentProps<
    "video",
    VideoPlayerPresentationProps & {
        /** Specifies the URL of the video file */
        src: string;
        /** Specifies that the video will start playing as soon as it is ready */
        autoPlay?: boolean;
        /** Specifies that video controls should be displayed (such as a play/pause button etc). */
        controls?: boolean;
        /** Sets the height of the video player */
        height?: number | string;
        /** Specifies that the video will start over again, every time it is finished */
        loop?: boolean;
        /** Specifies that the audio output of the video should be muted */
        muted?: boolean;
        /** Specifies an image to be shown while the video is downloading, or until the user hits the play button */
        poster?: string;
        /** Specifies if and how the author thinks the video should be loaded when the page loads */
        preload?: "auto" | "metadata" | "none";
        /** Sets the width of the video player */
        width?: number | string;
    }
>;

export const StyledVideoPlayer = styled.video<InjectableCss>`
    ${injectCss}
`;

const VideoPlayer: FC<VideoPlayerProps> = ({
    src,
    autoPlay = true,
    controls = false,
    height = "auto",
    loop = true,
    muted = true,
    poster,
    preload = "auto",
    width = "100%",
    css,
    ...otherProps
}) => {
    if (!src) {
        return null;
    }

    return (
        <StyledVideoPlayer
            {...otherProps}
            src={src}
            autoPlay={autoPlay}
            controls={controls}
            height={height}
            loop={loop}
            muted={muted}
            poster={poster}
            preload={preload}
            width={width}
            css={css}
        />
    );
};

export default VideoPlayer;
